import React from 'react'
import wrappedPropsToJs from '../functions/wrappedPropsToJs'

const toJS = () => WrappedComponent => {
    const ToJS = wrappedComponentProps => {
        const propsJS = wrappedPropsToJs(wrappedComponentProps)

        return <WrappedComponent {...propsJS} />
    }

    return ToJS
}

export default toJS